import wixWindow from 'wix-window';
$w.onReady(function () {
	if (wixWindow.multilingual.currentLanguage === "en")
	{
		$w('#statebox9').changeState("State2")
		$w('#statebox10').changeState("state2")
	}
	else
	{
		$w('#statebox9').changeState("State1")
		$w('#statebox10').changeState("state1")
	}
});